export type ContactModel = {
  id: number,
  attachment_data?: any,
  expiry_date: string,
  file_name?: string,
  owner_id: number,
  owner_type: string,
  start_date: string,
  title: string,
}

const state = {
  id: null,
  attachment_data: null,
  expiry_date: '',
  file_name: '',
  owner_id: undefined,
  owner_type: '',
  start_date: '',
  title: '',
}

export const requiredFields = [
  {
    key: 'expiry_date',
    validation: (value: string, entityState: ContactModel) => entityState.start_date <= value,
    invalidMessage: 'Invalid End Date',
  },
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'start_date' },
  { key: 'title' },
]

export default state
